import { ChatSocketService } from '@agent/agent-interface/contact-view/chat/services/chat-socket.service';
import { Component, OnInit } from '@angular/core';

import { BookingFacade, Qualification, UntilDestroy, untilDestroyed } from '@contact/upgrade';

@UntilDestroy()
@Component({
  selector: 'chat-qualification-tab-actions',
  templateUrl: 'chat-qualification-tab-actions.component.html',
  styleUrls: ['./chat-qualification-tab-actions.component.scss'],
})
export class ChatQualificationTabActionsComponent implements OnInit {
  public activeTab: string;
  public chatTab: string = 'chat';
  public qualificationTab: string = 'qualificationDeprecatedService';
  qualification: Qualification | undefined;

  constructor(private readonly contactFacade: BookingFacade, protected readonly chatSocketService: ChatSocketService) {}

  ngOnInit(): void {
    this.contactFacade.selectedQualif$.pipe(untilDestroyed(this)).subscribe(qualification => (this.qualification = qualification));
    this.goToChatBox();
  }

  goToChatBox(): void {
    this.activeTab = this.chatTab;
    this.synchronizeActiveChat();
  }

  goToQualification(): void {
    if (this.isPostTreatmentEnabled()) {
      this.activeTab = this.qualificationTab;
      this.synchronizeActiveChat();
    }
  }

  isChatSelected(): boolean {
    return this.activeTab === this.chatTab;
  }

  isQualificationSelected(): boolean {
    return this.activeTab === this.qualificationTab;
  }

  private synchronizeActiveChat(): void {
    if (this.chatSocketService.activeChat) {
      this.chatSocketService.activeChat.chatTabState = this.activeTab;
    }
  }

  public isPostTreatmentEnabled(): boolean {
    return !!this.qualification && this.qualification.displayForm;
  }

  public showActions(): boolean {
    return !!this.chatSocketService.activeChat && !this.chatSocketService.activeChat.inPostTreatmentMode;
  }
}
